"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("../constant");

var _constant3 = _interopRequireDefault(require("./constant"));

var _default = {
  PropTypes: {
    children: _propTypes.any,
    backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    overlayBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    overlayOpacity: _propTypes.string,
    onClose: _propTypes.func,
    openModal: _propTypes.bool,
    viewPort: _propTypes.string,
    title: _propTypes.string,
    zIndex: _propTypes.number,
    width: _propTypes.string,
    fullScreen: _propTypes.bool,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    showCloseIcon: _propTypes.bool,
    footerContent: _propTypes.any,
    modalCenter: _propTypes.bool,
    modalRightAlign: _propTypes.bool,
    showHeaderBorder: _propTypes.bool,
    headerTextColor: _propTypes.string,
    headerPaddingBottom: _propTypes.string,
    modalContentPaddingTop: _propTypes.string,
    modalContentOverflow: _propTypes.string,
    isDropdown: _propTypes.bool,
    customHeaderPadding: _propTypes.string,
    isPreventClose: _propTypes.bool,
    hasHeaderShadow: _propTypes.bool,
    fixedCloseBtn: _propTypes.bool,
    customContentProperties: (0, _propTypes.shape)({
      contentPadding: _propTypes.string
    })
  },
  DefaultProps: {
    backgroundColor: _constant3.default.BACKGROUND,
    overlayBackgroundColor: _constant3.default.OVERLAY_BG_COLOR,
    overlayOpacity: _constant3.default.OVERLAY_OPACITY,
    zIndex: _constant3.default.ZINDEX,
    openModal: true,
    viewPort: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    showCloseIcon: true,
    modalCenter: false,
    modalRightAlign: false,
    showHeaderBorder: true,
    headerTextColor: null,
    modalContentOverflow: _constant3.default.OVERFLOW,
    headerPaddingBottom: _constant3.default.HEADERPADDINGBOTTOM,
    modalContentPaddingTop: _constant3.default.MODALCONTENTPADDINGTOP,
    isDropdown: false,
    customHeaderPadding: null,
    isPreventClose: false,
    hasHeaderShadow: false,
    fixedCloseBtn: false,
    customContentProperties: {}
  }
};
exports.default = _default;